import SubmitSuccess from './SubmitSuccess';

export default SubmitSuccess;


// WEBPACK FOOTER //
// ./src/components/SubmitSuccess/index.js